<template>
  <div>
    <h3 class="hide-on-large gray-700 proposal-info-title">Resumo da proposta</h3>

    <div class="proposal-info-wrapper">
      <p class="details-title">
        Proposta
      </p>
      <p class="details-value">
        {{ proposalId }}
      </p>

      <p class="details-title">
        Código do boleto
      </p>
      <p class="details-value break-word">
        {{ barCodeNumber }}
      </p>

      <p class="details-title">
        Locatário
      </p>
      <p class="details-value">
        {{ name }}
      </p>

      <p class="details-title">
        CPF
      </p>
      <p class="details-value">
        {{ cpf | cpfFilter }}
      </p>

      <p class="details-title">
        Celular
      </p>
      <p class="details-value">
        {{ phone | phoneFilter }}
      </p>

      <div class="condition">
        <div class="condition-row">
          <p class="body-regular">Entrada de {{ downPaymentPercentage }}%</p>
          <p class="body-bold">{{ downPaymentValue | moneyFilter }}</p>
        </div>

        <Divisor class="condition-divisor" />

        <div class="condition-row">
          <p class="body-regular">Parcelas</p>
          <p class="body-bold">
            {{ numberOfInstallments }} vezes de {{ paymentInstallments| moneyFilter }}
          </p>
        </div>

        <Divisor class="condition-divisor" />

        <div class="condition-row">
          <p class="body-regular">Valor total</p>
          <div>
            <p class="body-bold">{{ totalAmount | moneyFilter }}</p>
            <p class="extra-condition-info">
              Juros de {{ interest | interestRateFilter }} a.m. + IOF.
              <br/>
              CET máximo de {{ cetPA | interestRateFilter }} a.a.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Divisor from '@/components/common/Divisor.vue';
import stringMixin from '@/mixins/string';

export default {
  name: 'proposalInfo',
  props: {
    proposalId: String,
  },
  components: {
    Divisor,
  },
  mixins: [stringMixin],
  computed: {
    ...mapState('tenant', ['proposal']),
    ...mapState('onboarding', [
      'name',
      'cpf',
      'phone',
      'totalAmount',
      'downPaymentValue',
      'installmentNumber',
      'installmentValue',
      'totalValue',
      'interest',
      'cetPA',
      'downPaymentPercentage',
      'downPaymentValue',
      'numberOfInstallments',
      'paymentInstallments',
      'interest',
      'cetPA',
      'barCodeNumber',
    ]),
  },
};
</script>

<style lang="scss" scoped>
  .proposal-info-wrapper {
    margin: 72px 0 0 36px;
  }

  .back-icon-bg {
    box-sizing: border-box;
    padding: 8px;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    border: 1px solid var(--gray-200);
  }

  .condition {
    margin-top: 36px;
  }

  .condition-row {
    text-align: right;
    display: flex;
    justify-content: space-between;
    color: var(--gray-700);
  }

  .condition-divisor {
    margin: 16px 0;
  }

  .extra-condition-info {
    @extend .small-regular;
    color: var(--gray-500);
  }

  .details-title {
    @extend .body-regular;
    color: var(--gray-700);
    margin-top: 16px;
  }

  .details-value {
    @extend .body-bold;
    color: var(--gray-700);
  }

  .break-word {
    max-width: 20em;
    word-wrap: break-word;
  }

  @media (max-width: $breakpoint-large) {
    .proposal-info-wrapper {
      margin: 0px;
    }

    .proposal-info-title {
      margin-left: 55px;
      margin-top: 10px;
    }
  }

</style>
